

function selectionCheckboxesReducer(screenState, action){

  if (action.type == 'UPDATE_CONTROL'){
    const { fieldKey } = action
    var field = screenState[fieldKey]
    if (field['checkboxSelected'] == true){
      // Enable checkboxs to be visible on all controls
      screenState = showAllCheckboxes(screenState)
    } else if (allCheckboxesAreUnselected(screenState)) {
      screenState = hideAllCheckboxes(screenState)
    }
  }
  return screenState
}

export default selectionCheckboxesReducer

/**
 * This goes through all the fields in the screen state and sets the field
 * property 'showCheckbox' to 'true'. Ignores pages and forms.
 * @param {object} screenState
 * @returns {object} A new screenState
 */
function showAllCheckboxes(screenState){
  screenState = Object.assign({}, screenState)
  Object.keys(screenState).forEach(key => {
    if (key == 'layout') return
    var field = screenState[key]
    if (field.type == 'page' || field.type == 'form') return
    screenState[key] = Object.assign({}, field, { 'showCheckbox': true })
  })
  return screenState
}

/**
 * Determines if all the checkboxes are unselected
 * @param {object} screenState
 * @returns {boolean}
 */
function allCheckboxesAreUnselected(screenState){
  return getAllSelectedCheckboxes(screenState).length == 0
}

/**
 * Hides all the checkboxes in the screen state
 * @param {object} screenState
 * @returns {object}
 */
function hideAllCheckboxes(screenState){
  screenState = Object.assign({}, screenState)
  Object.keys(screenState).forEach(key => {
    if (key == 'layout') return
    var field = screenState[key]
    if (field.type == 'page' || field.type == 'form') return
    screenState[key] = Object.assign({}, field, { 'showCheckbox': false })
  })
  return screenState
}

/**
 * Returns all the checkboxes that are selected in the screenState. Preserves
 * the order in which they appear, from top to bottom
 * @param {screenState}
 * @returns {Array<string>}
 */
export function getAllSelectedCheckboxes(screenState){

  var selectedFields = []

  function parseField(field){
    if (
      field == screenState ||
      field.type == 'page' ||
      field.type == 'form'
    )
      return field.layout.forEach(key => parseField(screenState[key]))

    if (field['checkboxSelected'] == true)
      selectedFields.push(field['key'])

  }

  parseField(screenState)

  return selectedFields
}


// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/editorReducer/selectionCheckboxes.js